<main class="notice-page" aria-labelledby="notice-title">
  <section class="notice-content">
    <img class="notice-logo" src="assets/logo.png" alt="Arias" />

    <h1 id="notice-title">Cambio de direcci&oacute;n de acceso</h1>

    <p>
      La plataforma de solicitudes ya est&aacute; disponible en su
      <strong>nueva direcci&oacute;n web:</strong>
      <a class="notice-link" href="https://profesionales-formulas-arias.healthfinder.es">
        profesionales-formulas-arias.healthfinder.es
      </a>
    </p>

    <p>
      La direcci&oacute;n actual est&aacute; obsoleta y dejar&aacute; de estar
      disponible pr&oacute;ximamente, por lo que le recomendamos actualizar sus
      favoritos o marcadores para acceder siempre desde el nuevo enlace.
    </p>

    <p>Gracias por su colaboraci&oacute;n.</p>

    <p class="notice-link-row">
      <strong>
        <a class="notice-link" href="https://profesionales-formulas-arias.healthfinder.es">
          profesionales-formulas-arias.healthfinder.es
        </a>
      </strong>
    </p>
  </section>
</main>
